module.exports = __webpack_public_path__ + "img/heroes-of-asgard.e58bd546.svg";